import theme from "Styles/theme";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

const GlobalStyle = createGlobalStyle`
  ${reset}
  
  *{
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent; /* for removing the highlight */
  }

  body{
    font-family: 'Noto Sans KR', sans-serif;
    ${theme.text.default};
    background-color: ${theme.color.bg}; 

  }

  a{
    text-decoration:none; 
    color:inherit;
  }

  li{
    list-style: none;
  }
  
`;

export default GlobalStyle;
